import { render, staticRenderFns } from "./subLocationListEditor.vue?vue&type=template&id=30a677da"
import script from "./subLocationListEditor.vue?vue&type=script&lang=js"
export * from "./subLocationListEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports